<script setup>
import { ref, onMounted } from 'vue'
import { parse_notification_description, formattedDate, humanizeText, swalError, swalSuccess } from '@/helper';
import { get_trait } from '@/services/packages';
import { mark_as_seen } from '@/services/notifications';
import infoCard from './infoCard.vue'

const props = defineProps({
  notification: {
    type: Object
  }
})
const isLoading = ref(false)
const name = ref('')
onMounted(async()=>{
  isLoading.value = true
  await check_type(props.notification)
  // get_trait_name(props.notification.meta.trait_id)
  isLoading.value = false
})

async function get_trait_name(trait_id){
  let response = await get_trait(trait_id)
  if (response.error){
    swalError(response.result.error)
    name.value = '-'
    return 
  }
  name.value = response.result.data.attributes.name
}

const showInfo = ref(false)

async function mark_seen(notification){
  let data = {seen_by_user: true}
  let response = await mark_as_seen(notification.id, data)
  if (!response.error){
    swalSuccess('Notification has been mark as seen', false, 'Updated',)
    notification.attributes = response.result.data.data.attributes
  }
}

const linkData = ref({
  name: '',
  params: {}
})
const subject = ref('Your')
const description = ref('')
const needInfo = ref(true)
async function check_type(notification){
  switch (notification.entity_type.attributes.entity) {
    case "support":
      needInfo.value = false
      break;
    case "feedback":
      needInfo.value = false
      break;
    case "system_feedback":
      needInfo.value = false
      break;
    case "new_report":
      linkData.value.name = 'dna-report-single-application'
      linkData.value.params = { id: notification.meta.id }
      needInfo.value = false
      break;
    case "update_report":
      linkData.value.name = 'dna-report-single-application'
      linkData.value.params = { id: notification.meta.id }
      needInfo.value = false
      break;
    case "report":
      linkData.value.name = 'dna-report-single-application'
      linkData.value.params = { id: notification.meta.child_id }
      subject.value = notification.meta.child_name
      description.value = notification.meta.description
      needInfo.value = false
      break;
    case "assessment":
      needInfo.value = true
      await get_trait_name(props.notification.meta.trait_id)
      break;
    default:
      break;
  }
}

function get_description(){
  return parse_notification_description(props.notification)
}
</script>

<template>
  <div class="d-flex justify-content-between align-items-center">
    <div class="col-md-6">
      <p class="text-secondary activity-date-top mb-0">
        {{ formattedDate(notification.attributes.created_at) }}
      </p>
      <p class="mb-0 fw-bold text-capitalize">
        {{ humanizeText(notification.entity_type.attributes.entity) }}
      </p>
      <p>
        {{ get_description() }}
      </p>
    </div>
    <div class="col-md-4 d-flex justify-content-end">
      <template v-if="needInfo">
        <div></div>
        <!-- <button class="me-2 btn icon-btn btn-light-warning" 
          @click="showInfo = !showInfo"
          
        >
          <vue-feather type="more-horizontal"></vue-feather>
        </button> -->
      </template>
      <template v-else>
        <template v-if="linkData.name !== ''">
          <router-link :to="{name: linkData.name, params: linkData.params}"
            class="me-2 btn icon-btn btn-light-success"
          >
            <vue-feather type="chevron-right"></vue-feather>
          </router-link>
        </template>
      </template>
      <button class="btn icon-btn btn-light-primary"
        v-if="!notification.attributes.seen_by_user"
        @click="mark_seen(notification)"
      >
        <vue-feather type="check"></vue-feather>
      </button>
    </div>
    <div class="col-md-2 ms-3 activity-date-side">
      <p>{{ formattedDate(notification.attributes.created_at, {time: true}) }}</p>
    </div>
  </div>
  <div v-if="showInfo">
    <infoCard :notification="notification"/>
  </div>
</template>